/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
export default {
  "sitecoreApiKey": "no-api-key-set",
  "sitecoreSCApiKey": "",
  "sitecoreApiHost": "",
  "jssAppName": "hoteljen",
  "encryption_key": "",
  "encryption_iv": "",
  "openapi_appid": "",
  "openapi_appsecret": "",
  "mysql_host": "",
  "mysql_database": "",
  "mysql_user": "",
  "mysql_password": "",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/hoteljen",
  "graphQLEndpoint": "/api/hoteljen?sc_apikey="
};